import i18n from 'src/i18n/i18n';

export const normalizeFiltersResponse = (data) => {
  let response = [];

  for (const key in data) {
    response.push(data[key]);
  }

  return [...response, { name: '', translate: i18n.t('exchange:all') }];
};
